import React, { useEffect, useState, useMemo } from 'react';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import withRouter from '../../components/Common/withRouter';
import TableContainer from '../../components/Common/TableContainer';
import Spinners from '../../components/Common/Spinner';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useAuthStore } from '../../zustand-store/auth.store';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import VerticalLayout from '../../components/VerticalLayout';
import { appFeeData } from '../../axios/appointment/index.api';
import * as XLSX from 'xlsx';

const AllTimeFees = () => {
  document.title = 'All Time App Fee Report';

  const locationId = useAuthStore((state) => state.locationId);
  const [pageSize, setPageSize] = useState(100);

  const ContactsProperties = createSelector(
    (state) => state.contacts,
    (Contacts) => ({
      users: Contacts?.users,
      loading: Contacts?.loading
    })
  );

  const { loading } = useSelector(ContactsProperties);
  const [isLoading, setLoading] = useState(loading);
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState('This Month');
  const [monthYearOptions, setMonthYearOptions] = useState([]);

  // Modal & Date Range State
  //   const [modalOpen, setModalOpen] = useState(false);
  //   const [dateRange, setDateRange] = useState([
  //     {
  //       startDate: new Date(),
  //       endDate: new Date(),
  //       key: 'selection'
  //     }
  //   ]);

  useEffect(() => {
    localStorage.setItem('path', '/reports/revenuereport');
    getData();
  }, [locationId]);

  const getData = async () => {
    setLoading(true);
    let res = await appFeeData();
    console.log(res?.data?.data.length, '===========');
    const report = res?.data?.data || [];

    const uniqueMonthYears = [...new Set(report.map((item) => item.monthYear))];
    setMonthYearOptions(['This Month', 'All', ...uniqueMonthYears]);

    setData(res);
    setFilteredData(filterByMonthYear(report, 'This Month'));

    setLoading(false);
  };
  const totalAppFee = useMemo(() => {
    return (filteredData || []).reduce((sum, item) => {
      const feeStr = item.totalAppFee?.replace(/[^\d.]/g, ''); // remove £ or any non-numeric chars
      const fee = parseFloat(feeStr) || 0;
      return sum + fee;
    }, 0);
  }, [filteredData]);
  const filterByMonthYear = (data, selected) => {
    if (selected === 'All') return data;

    if (selected === 'This Month') {
      const now = new Date();
      const currentMonthYear = `${now
        .toLocaleString('default', {
          month: 'short'
        })
        .slice(0, 3)}, ${now.getFullYear()}`;
      return data.filter((item) => item.monthYear === currentMonthYear);
    }

    return data.filter((item) => item.monthYear === selected);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setSelectedMonthYear(value);

    const reportData = data?.data?.data || [];
    setFilteredData(filterByMonthYear(reportData, value));
  };

  //   const handleDateFilter = () => {
  //     const reportData = data?.data?.data?.smsAndEmailReport || [];

  //     const start = startOfMonth(dateRange[0].startDate);
  //     const end = endOfMonth(dateRange[0].endDate);

  //     const filtered = reportData.filter((item) => {
  //       try {
  //         const itemDate = parse(item.monthYear, 'MMM, yyyy', new Date());
  //         console.log(itemDate, start, end);
  //         return itemDate >= start && itemDate <= end;
  //       } catch (err) {
  //         console.error('Date parse error for item:', item, err);
  //         return false;
  //       }
  //     });

  //     console.log('Filtered:', filtered);
  //     setFilteredData(filtered);
  //     setModalOpen(false);
  //   };

  const columns = useMemo(
    () => [
      {
        header: 'Business Name',
        accessorKey: 'businessName',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Location Name',
        accessorKey: 'locationName',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Month Year',
        accessorKey: 'monthYear',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Total App Fee',
        accessorKey: 'totalAppFee',
        enableColumnFilter: false,
        enableSorting: true
      }
    ],
    []
  );

  const handleExport = () => {
    const reportData = filteredData || [];

    if (reportData.length === 0) return;

    const worksheet = XLSX.utils.json_to_sheet(
      reportData.map((item) => ({
        'Business Name': item.businessName,
        'Location Name': item.locationName,
        'Month Year': item.monthYear,
        'Total App Fee': item.totalAppFee
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Total App Fee');
    XLSX.writeFile(workbook, 'Total_App_Fee.xlsx');
  };

  return (
    <VerticalLayout>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="App Fee Report" breadcrumbItem="App Fee Report" />
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between mb-3">
                      <div className="d-flex gap-2">
                        <select
                          className="form-select"
                          value={selectedMonthYear}
                          onChange={handleFilterChange}
                          style={{ width: '200px' }}
                        >
                          {monthYearOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        {/* <Button color="primary" onClick={() => setModalOpen(true)}>
                          <i className="bx bx-filter text-light" style={{ fontSize: 20 }} />
                        </Button> */}
                      </div>
                      <Button color="primary" onClick={handleExport}>
                        Export to Excel
                      </Button>
                    </div>
                    <TableContainer
                      columns={columns}
                      data={filteredData}
                      isPagination={false}
                      isServerPagination={true}
                      allowFilters={false}
                      isGlobalFilter={false}
                      SearchPlaceholder="Search..."
                      isCustomPageSize={true}
                      buttonClass="btn bg-primary rounded-pill addContact-modal mb-2 px-4"
                      tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination"
                      pageSizeOptions={[100, 200]}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      tourId="open-add-service-modal"
                    />
                  </CardBody>
                </Card>
              </Col>
              {/* Footer Total Row */}
              <div className="d-flex justify-content-end mt-3">
                <h5>
                  Total App Fee:{' '}
                  <span className="fw-bold">
                    £{totalAppFee.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </span>
                </h5>
              </div>
           <div
  className="d-flex justify-content-end mt-3"
  style={{ cursor: 'pointer' }}
  title={`Average = £${totalAppFee.toLocaleString(undefined, {
    minimumFractionDigits: 2,
  })} / ${new Date().getDate()} days`}
>
  <h5>
    Average:{' '}
    <span className="fw-bold">
      £{(totalAppFee / new Date().getDate()).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })}
    </span>
  </h5>
</div>
            </Row>
          )}
        </Container>
      </div>

      {/* Date Range Modal
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="xl">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Filter by Date Range</ModalHeader>
        <ModalBody>
          <DateRangePicker
            editableDateInputs={true}
            onChange={(item) => setDateRange([item.selection])}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            months={2}
            direction="horizontal"
            rangeColors={['#000']}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleDateFilter}>
            Apply
          </Button>{' '}
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal> */}

      <ToastContainer />
    </VerticalLayout>
  );
};

export default withRouter(AllTimeFees);
